import {
  SchedulerForm,
  SchedulerFormProps,
} from "@progress/kendo-react-scheduler";
import { CustomFormDialog } from "./customFormDialog";
import React, { useState } from 'react';

import { FormsDateDetail, FormsDetail, FormsHeureDetail } from '../../interface/planning/planning';
import { useConf } from "../../context/account/paramsAccount";
import { useError } from "../../context/erreur/erreurContext";
interface CustomModalProps {
  dataItem: any;
  onClose: () => void;
}
export const CustomModal = (props: SchedulerFormProps) => {
  return <SchedulerForm {...props} dialog={CustomFormDialog} />;
};

const apiUrl = process.env.REACT_APP_API_URL;

// Utilisez directement les données de la tâche transmises via les props
export const CustomModalWeek: React.FC<CustomModalProps> = ({ dataItem, onClose }) => {
  const { conf, setConf }: any = useConf();
  const { showError } = useError();

  const timeStartString = dataItem?.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const timeEndString = dataItem?.end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const dateStartString = dataItem?.start.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' });
  const dateEndString = dataItem?.end.toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' });


  const dateForms: FormsDateDetail[] = [{
    dateStart: {
      title: 'Date debut:',
      value: dateStartString
    },
    dateEnd: {
      title: 'Date fin:',
      value: dateEndString
    }
  }
  ]
  const horaireForms: FormsHeureDetail[] = [{
    horaireStart: {
      title: 'Horaire debut:',
      value: timeStartString
    },
    horaireEnd: {
      title: 'Horaire fin:',
      value: timeEndString
    }
  }
  ]
  const DetailForms: FormsDetail[] = [{
    client: {
      title: 'Client:',
      value: dataItem?.title,
    },
    cli_tel_fixe: {

      title: 'Téléphone:',
      value: dataItem?.cli_tel_fixe,
    },
    cli_tel_mobile: {
      title: 'Mobile:',
      value: dataItem?.cli_tel_mobile,
    },
    v_cnt1_civ_nom: {
      title: 'Contact:',
      value: dataItem?.v_cnt1_civ_nom,
    },
    v_cnt1_tel_fixe: {
      title: 'Fixe:',
      value: dataItem?.v_cnt1_tel_fixe,
    },
    v_cnt1_tel_mobile: {

      title: 'Mobile:',
      value: dataItem?.v_cnt1_tel_mobile,
    },
    v_cnt2_civ_nom: {
      title: 'Contact:',
      value: dataItem?.v_cnt2_civ_nom,
    },
    v_cnt2_tel_fixe: {

      title: 'fixe:',
      value: dataItem?.v_cnt2_tel_fixe,
    },
    v_cnt2_tel_mobile: {

      title: 'Mobile:',
      value: dataItem?.v_cnt2_tel_mobile,
    },
    description: {
      title: 'Description',
      value: dataItem?.v_desc,
    },
    typeDePrestation: {
      title: 'Type de prestation',
      value: dataItem?.v_type_presta,
    },
    modeDeVente: {
      title: 'Mode de vente',
      value: dataItem.modeVente === undefined ? dataItem.v_mode_vente : dataItem?.modeVente,
    },

    avancement: {
      title: 'Avancement',
      value: dataItem?.v_lib_avancement,
    },
    nombreDeConvive: {
      title: 'Nombre de convive',
      value: dataItem?.v_nbre_convive,
    },
    lieu: {
      title: 'Lieu',
      value: dataItem?.v_lieu_civ_nom,
    },
  }
  ]
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  function testButton(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();

    if (!conf.token) return;

    const data = { vpr_id: dataItem.vpr_id };

    fetch(`${apiUrl}/posts/generate-etat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${conf.token}`,
      },
      body: JSON.stringify(data),
    })
      .then(async (res) => {
        // Si erreur côté backend → lire le JSON et afficher le message
        if (!res.ok) {
          const errorJson = await res.json().catch(() => null);

          if (errorJson?.message) {
            showError(errorJson.message);
          } else {
            showError("Erreur lors de la génération du PDF");
          }

          throw new Error("STOP"); // Empêche la suite
        }

        // Sinon → c'est un PDF
        return res.blob();
      })
      .then(async (blob) => {
        if (!blob) return;

        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      })
      .catch((err) => {
        if (err.message !== "STOP") {
          showError("Erreur inattendue");
        }
      });
  }



  return (
    <>
      <div className="headerDC">
      </div>
      <div className='mobileContainerDetail gridDate '>
        {dateForms.map((data, index) => (
          <React.Fragment key={`date-${index}`}>
            <ComposantDetail title={data.dateStart.title} value={data.dateStart.value} />
            <ComposantDetail title={data.dateEnd.title} value={data.dateEnd.value} />
          </React.Fragment>
        ))}
        {horaireForms.map((data, index) => (
          <React.Fragment key={`date-${index}`}>
            <ComposantDetail title={data.horaireStart.title} value={data.horaireStart.value} />
            <ComposantDetail title={data.horaireEnd.title} value={data.horaireEnd.value} />
          </React.Fragment>
        ))}

      </div>
      {DetailForms.map((data, index) => (
        <React.Fragment key={`date-${index}`}>
          <div className='gridDate'>
            <ComposantDetail title={data.client.title} value={data.client.value} />
            <ComposantDetail title={data.description.title} value={data.description.value} />
            <ComposantDetail title={data.typeDePrestation.title} value={data.typeDePrestation.value} />
            <ComposantDetail title={data.modeDeVente.title} value={data.modeDeVente.value} />
            <ComposantDetail title={data.avancement.title} value={data.avancement.value} />
            <ComposantDetail title={data.nombreDeConvive.title} value={data.nombreDeConvive.value} />
            <ComposantDetail title={data.lieu.title} value={data.lieu.value} />
            <button className="generatorPdf" onClick={testButton}>Générer le bon de préparation</button>
          </div>
          {
            data.v_cnt1_tel_fixe.value !== null ?
              <>
                <ComposantDetail title={data.v_cnt1_civ_nom.title} value={data.v_cnt1_civ_nom.value} />
                <div className='dateDetail'>
                  <ComposantDetail title={data.v_cnt1_tel_fixe.title} value={data.v_cnt1_tel_fixe.value} />
                  <ComposantDetail title={data.v_cnt1_tel_mobile.title} value={data.v_cnt1_tel_mobile.value} />
                </div>
              </>
              : data.v_cnt2_tel_fixe.value !== null ? <>
                <ComposantDetail title={data.v_cnt2_civ_nom.title} value={data.v_cnt2_civ_nom.value} />
                <div className='dateDetail'>
                  <ComposantDetail title={data.v_cnt2_tel_fixe.title} value={data.v_cnt2_tel_fixe.value} />
                  <ComposantDetail title={data.v_cnt2_tel_mobile.title} value={data.v_cnt2_tel_mobile.value} />
                </div>
              </>
                : data.cli_tel_fixe.value !== null ? <>
                  <ComposantDetail title={data.cli_tel_fixe.title} value={data.cli_tel_fixe.value} />
                  <ComposantDetail title={data.cli_tel_mobile.title} value={data.cli_tel_mobile.value} />

                </> : ''

          }
        </React.Fragment>
      ))}
      {/* {pdfUrl && (
        <div style={{ marginTop: "20px", height: "600px" }}>
          <iframe
            src={pdfUrl}
            width="100%"
            height="100%"
            title="PDF Etat"
          />
        </div>
      )}</> */
      }</>
  );
};
function ComposantDetail({ title, value }: any) {
  return <>
    <div className="k-form-field" >
      <label htmlFor={title}>{title}</label>
      <input
        readOnly
        type="text"
        name={title}
        value={value || ''}
      />
    </div >
  </>
};